// extracted by mini-css-extract-plugin
export var base = "Button-module--base--e8c71";
export var dark = "Button-module--dark--09623";
export var primary = "Button-module--primary--2a969";
export var transparent = "Button-module--transparent--13be5";
export var twitter = "Button-module--twitter--775d8";